export default __webpack_public_path__ + "4168b9c11e5075e9cfe634a513b438f2.ttf";